import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../store/AppContext";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../../../styles/Bienvenida.css";
import SnakeGame from "./SnakeGame";

const Bienvenida = () => {
	const { store, actions } = useContext(Context);
	const [click, setClick] = useState(false);
	const [celebracion, setCelebracion] = useState({
		nombre: null,
		fecha: null,
	});
	const [mesFeriado, setMesFeriado] = useState(new Date().getMonth());
	const [animar, setAnimar] = useState(false);
	const [mostrarLinks, setMostrarLinks] = useState(false);

	useEffect(() => {
		setAnimar(true);
	}, []);

	/* Objeto de Fechas de Cumpleaños */
	const fechas = {
		"constanza villarroel": new Date(2020, 9, 17),
		erick: new Date(2020, 0, 7),
		gislen: new Date(2020, 0, 22),
		italia: new Date(2020, 1, 3),
		araxy: new Date(2020, 1, 17),
		jennyfer: new Date(2020, 2, 12),
		javiera: new Date(2020, 5, 25),
		"constanza montero": new Date(2020, 2, 8),
		"ricardo anselmi": new Date(2020, 3, 6),
		colomba: new Date(2020, 4, 3),
		doriz: new Date(2020, 4, 12),
		rosa: new Date(2020, 5, 9),
		rodrigo: new Date(2020, 7, 2),
		emilio: new Date(2020, 7, 4),
		matias: new Date(2020, 8, 20),
		"ricardo flores": new Date(2020, 10, 12),		
	};

	/* Lista de Feriados debe ser actualizada Anualmente */
	const feriados = [
		{ feriado: "Año Nuevo", date: new Date(2024, 0, 1) },
		{ feriado: "Viernes Santo", date: new Date(2024, 3, 3) },
		{ feriado: "Sábado Santo", date: new Date(2024, 3, 4) },
		{ feriado: "Día Nacional del Trabajo", date: new Date(2024, 4, 1) },
		{ feriado: "Día de las Glorias Navales", date: new Date(2024, 4, 21) },
		{
			feriado: "Día Nacional de los Pueblos Indígenas",
			date: new Date(2024, 5, 21),
		},
		{ feriado: "San Pedro y San Pablo", date: new Date(2024, 5, 29) },
		{ feriado: "Día de la Virgen del Carmen", date: new Date(2024, 6, 16) },
		{ feriado: "Asunción de la Virgen", date: new Date(2024, 7, 15) },
		{ feriado: "Independencia Nacional", date: new Date(2024, 8, 18) },
		{ feriado: "Día de las Glorias del Ejército", date: new Date(2024, 8, 19) },
		{ feriado: "Encuentro de Dos Mundos", date: new Date(2024, 9, 12) },
		{
			feriado: "Día de las Iglesias Evangélicas y Protestantes",
			date: new Date(2024, 9, 31),
		},
		{ feriado: "Día de Todos los Santos", date: new Date(2024, 10, 1) },
		{ feriado: "Inmaculada Concepción", date: new Date(2024, 11, 8) },
		{ feriado: "Navidad", date: new Date(2024, 11, 25) },
	];

	const ListaFeriados = (objeto, i) => {
		if (objeto.date.getMonth() === mesFeriado) {
			return (
				<li key={i}>
					<small>Día {objeto.date.getDate()}: {objeto.feriado}</small>
				</li>
			);
		}
	};

	// Función para obtener cumpleaños del mes seleccionado en el calendario
	const obtenerCumpleañosDelMes = () => {
		const cumpleañosDelMes = [];
		
		Object.keys(fechas).forEach((key) => {
			if (fechas[key].getMonth() === mesFeriado) {
				cumpleañosDelMes.push({
					nombre: key.toUpperCase(),
					fecha: fechas[key]
				});
			}
		});
		
		return cumpleañosDelMes;
	};

	// Función para obtener el nombre del mes en español
	const obtenerNombreMes = (mes) => {
		const meses = [
			'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
			'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
		];
		return meses[mes];
	};

	// Función para verificar si hay feriados en el mes seleccionado
	const hayFeriadosEnElMes = () => {
		return feriados.some(feriado => feriado.date.getMonth() === mesFeriado);
	};

	const HandlerClickCalendario = (value, event) => {
		if (event) {
			setCelebracion({
				nombre: null,
				fecha: null,
			});
			setClick(false);
		}
		if (
			Object.values(fechas).some(
				(fecha) =>
					fecha.getMonth() === value.getMonth() &&
					fecha.getDate() === value.getDate()
			)
		) {
			Object.keys(fechas).forEach((key) => {
				if (
					fechas[key].getMonth() === value.getMonth() &&
					fechas[key].getDate() === value.getDate()
				) {
					setCelebracion({
						nombre: key.toUpperCase(),
						fecha: fechas[key],
					});
					setClick(true);
				}
			});
		}
	};

	// Verificar que usuarioActual existe antes de renderizar
	if (!store.usuarioActual || !store.usuarioActual.nombre) {
		return null;
	}

	return (
		<div className={`divGenerador ${animar && "animar"}`}>
			{/* Botón flotante para mostrar/ocultar links */}
			<button 
				className={`btn-flotante-links ${mostrarLinks ? 'activo' : ''}`}
				onClick={() => setMostrarLinks(!mostrarLinks)}
				title={mostrarLinks ? 'Ocultar Links' : 'Mostrar Links de Interés'}
			>
				{mostrarLinks ? '>>>' : '<<<'}
			</button>

			{/* Panel flotante con links de interés */}
			{mostrarLinks && (
				<div className='panel-links-flotante'>
					<div className='cell small-6'>
						<h5>Links de Interés</h5>
						<ul className='callout'>
							<li>
								<a
									href='https://denegocios.cl/'
									target='_blank'
									rel='noopener noreferrer'
								>
									Página de DeNegocios.cl
								</a>
							</li>
							<li>
								<a
									href='https://go.denegocios.cl/'
									target='_blank'
									rel='noopener noreferrer'
								>
									Acrilicos GO
								</a>
							</li>
							<li>
								<a
									href='https://www2.sii.cl/stc/noauthz'
									target='_blank'
									rel='noopener noreferrer'
								>
									Informacion de Terceros (SII)
								</a>
							</li>
							<li>
								<a
									href='https://www2.sii.cl/vicana/Menu/ConsultarAntecedentesSC'
									target='_blank'
									rel='noopener noreferrer'
								>
									Consultar Antecedentes de una Propiedad
								</a>
							</li>
							<li>
								<a
									href='https://dequienes.cl/'
									target='_blank'
									rel='noopener noreferrer'
								>
									De Quienes.cl
								</a>
							</li>
							<li>
								<a
									href='https://tramites.munistgo.cl/pagopatente/'
									target='_blank'
									rel='noopener noreferrer'
								>
									Consultar Pantente Municipal Santiago
								</a>
							</li>
							<li>
								<a
									href='https://www.registrocivil.cl/principal/servicios-en-linea/consulta-vigencia-documento-1'
									target='_blank'
									rel='noopener noreferrer'
								>
									Revisar Vigencia Cédula Identidad
								</a>
							</li>
							<li>
								<a
									href='https://denegocios.cl/giros-sii-buscador/'
									target='_blank'
									rel='noopener noreferrer'
								>
									Códigos/Giros del SII
								</a>
							</li>
							<li>
								<a
									href='https://www.registrodeempresasysociedades.cl/ObtenerCertificadosHome.aspx'
									target='_blank'
									rel='noopener noreferrer'
								>
									Obtener Documentos Empresa en 1 Día
								</a>
							</li>
							<li>
								<a
									href='https://conservador.cl/portal/indice_comercio'
									target='_blank'
									rel='noopener noreferrer'
								>
									Registro de Comercio de Santiago (Tradicionales)
								</a>
							</li>
						</ul>
					</div>
				</div>
			)}

			<div className='row'>
				<div className='column'>
					<h2>Hola {store.usuarioActual.nombre}, Bienvenid@.</h2>
					{Object.values(fechas).some(
						(fecha) =>
							fecha.getMonth() === new Date().getMonth() &&
							fecha.getDate() === new Date().getDate()
					) && (
						<div className='suph1'>
							<h1 className='h1'>🎂 Hoy hay Cumpleaños! 🎉</h1>
						</div>
					)}
					<hr />
					{click && celebracion.nombre ? (
						<div className='celebracion-banner'>
							<span>
								🎂 Cumpleaños de <strong>{celebracion.nombre}</strong>
								{celebracion.fecha
									? ` · Día ${celebracion.fecha.getDate()}`
									: ""}
							</span>
							<button
								type='button'
								className='celebracion-cerrar'
								onClick={() => {
									setClick(false);
									setCelebracion({ nombre: null, fecha: null });
								}}
								aria-label='Cerrar'
							>
								×
							</button>
						</div>
					) : null}
					<div className='row'>
						<div className='columns small-5'>
							<Calendar
								locale='es-cl'
								onClickDay={(value, event) =>
									HandlerClickCalendario(value, event)
								}
								onActiveStartDateChange={({
									action,
									activeStartDate,
									value,
									view,
								}) => setMesFeriado(activeStartDate.getMonth())}
								showNeighboringMonth={false}
								tileClassName={({ date, view }) =>
									Object.values(fechas).some(
										(fecha) =>
											fecha.getDate() === date.getDate() &&
											fecha.getMonth() === date.getMonth()
									)
										? "cumple"
										: feriados.some(
												(fecha) =>
													fecha.date.getDate() === date.getDate() &&
													fecha.date.getMonth() === date.getMonth()
										)
										? "feriado"
										: null
								}
							/>
						</div>
						<div className='columns small-7'>
						    &nbsp;
							&nbsp;
							<SnakeGame percentageWidth={60} />
						</div>
						
					</div>
					<div className='row' style={{ marginTop: "20px" }}>
						<div className='columns small-4'>
							<h5>Fechas Importantes</h5>
							<ul>
								<li>
									<small>Dia 13: Fecha Máxima Pago Previred (Remuneraciones)</small>
								</li>
								<li>
									<small>Dia 20: Fecha Máxima Pago Impuestos al SII (F29 con pago)</small>
								</li>
								<li>
									<small>Dia 28: Fecha Máxima F29 sin pago</small>
								</li>
							</ul>
						</div>
						<div className='columns small-4'>
							<h5>Feriados</h5>
							<ul>
								{hayFeriadosEnElMes() ? (
									feriados != null &&
									feriados.map((objeto, i) => ListaFeriados(objeto, i))
								) : (
									<li>
										<small>Nooo!, no hay feriados. Dolor.</small>
									</li>
								)}
							</ul>
						</div>
						<div className='columns small-4'>
							<div>
								<h5>Cumpleaños de {obtenerNombreMes(mesFeriado)}</h5>
								<ul>
									{obtenerCumpleañosDelMes().length > 0 ? (
										obtenerCumpleañosDelMes().map((cumpleaños, index) => (
											<li key={index}>
												<small>
													Día {cumpleaños.fecha.getDate()}: Feliz Cumpleaños{" "}
													{cumpleaños.nombre} ❤️
												</small>
											</li>
										))
									) : (
										<li>
											<small>Sadly este mes no hay nadien de cumple :(</small>
										</li>
									)}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Bienvenida;
